import { SERVER_URL } from "./http";
// import { ARTIST_SCOPES } from "../constants/general";
import React from "react";

import { searchContactsRoute } from "./routes/searchContacts";
import { getUsersRoute } from "./routes/getUsers";
import { getAvailableTimeSlotsRoute } from "./routes/getAvailableTimeSlots";
import { createCalendarEventRoute } from "./routes/createCalendarEventAndInvoice";

const myNewDate = (date) => {
  let newDate = new Date(date);
  if (!isNaN(newDate)) return newDate;
  return new Date(date.replace(" ", "T"));
};

export const searchContacts = async (email, setContact, setIncorrectEmail) => {
  const res = await searchContactsRoute(email);
  console.log("RES:", res);
  if (!res) {
    setIncorrectEmail(true);
  } else {
    setIncorrectEmail(false);
  }

  setContact(res);
};

export const getUsers = async (setUsers) => {
  const res = await getUsersRoute();
  console.log("RES:", res);
  setUsers(res);
};

export const getAvailableTimeSlots = async (
  userId,
  duration,
  date,
  setAvailableTimeSlots,
  callback
) => {
  date = myNewDate(date);
  date = date.toISOString().slice(0, 10);

  const res = await getAvailableTimeSlotsRoute(userId, duration, date);

  console.log("RES:", res);
  setAvailableTimeSlots(res);
  callback();
};

export const createCalendarEvent = async (
  eventName,
  startDatetime,
  endDatetime,
  studioId,
  userId,
  contactId,
  sessionType,
  duration,
  hourlyPrice,
  setEventCreated
) => {
  sessionType = sessionType === "mix" ? "Mix Session" : "Tracking Session";
  const res = await createCalendarEventRoute(
    eventName,
    startDatetime,
    endDatetime,
    studioId,
    userId,
    contactId,
    sessionType,
    duration,
    hourlyPrice
  );

  console.log("RES:", res);
  //setEventCreated(JSON.parse(res));
};
